<template>
    <div class="modal fade pdfModal responsiveModal" tabindex="-1" role="dialog" :id="id" ref="root">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="modalIdNr"><i class="far fa-file-pdf"></i> {{title}}</span>
                    <button type="button"  data-bs-dismiss="modal" class="btn-close float-end" @click="closePDF"></button>
                </div>
                <div class="modal-body" ref="modal-body">
                    <div v-if="loading" class="d-flex justify-content-center spinner-margin"><i class="fas fa-spinner fa-spin"></i></div>
                    <canvas v-show="!loading" v-for="index in pageIndexes" :id="`${id}-canvas-${index}`"></canvas>
                </div>
                <div class="modal-footer pdf-modal-footer">
                    <button type="button" class="btn btn-default" data-bs-dismiss="modal" v-text="lang('close')" @click="closePDF"></button>
                    <!--                    <button type="button" class="btn btn-success" data-bs-dismiss="modal" :disabled="scrollEnd ? false : 'disabled'" v-text="lang('agree')" @click="$emit('agree')"></button>-->
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<script>
    export default {
        name: "np-pdf-modal",
        props: {
            url: String,
            id: String,
            title: String,
        },
        data: function () {
            return {
                pageCount: 0,
                pages: [],
                pdfUrl: '',
                loadedPdf: null,
                scrollEnd: false,
                loading: true,
            }
        },
        computed: {
            pageIndexes: function () {
                const tmp = [];
                for(let i=1; i<= this.pageCount; i++) {
                    tmp.push(i);
                }
                return tmp;
            }
        },
        created: function () {
        },
        mounted: function () {
            const modalBody = this.$refs['modal-body'];
            const vm = this;
            vm.pdfUrl = vm.url;
            $(modalBody)
                .on('scroll', function (e) {
                    let ele = e.target;
                    if (ele.offsetHeight + ele.scrollTop >= ele.scrollHeight) {
                        vm.scrollEnd = true;
                    }
                });
            const root = this.$refs.root;
            $(root).on('shown.bs.modal', () => {
                this.fetch(this.url);
            })
            // document.addEventListener('webviewerloaded', function() {
            //     PDFViewerApplicationOptions.set('printResolution', 300);
            // });
        },
        methods: {
            closePDF() {
                let vm = this;
                vm.pdfUrl = '';
                vm.pageCount = 0;
                vm.scrollEnd = false;
                vm.loading = true;
            },
            fetch(url) {
                const vm = this;


                this.loadedPdf = pdfjsLib.getDocument(url)
                    .then(doc => {
                        const pageCount = doc.numPages;
                        vm.pageCount = pageCount;
                        vm.$nextTick(() => {
                            for(let i = 1; i <= pageCount; i++) {
                                doc.getPage(i)
                                    .then(page => {
                                        const canvasId = `${this.id}-canvas-${i}`;
                                        const canvas = document.getElementById(canvasId);
                                        const context = canvas.getContext('2d');
                                        const scale = 1.5;
                                        const viewport = page.getViewport(scale);
                                        canvas.height = viewport.height;
                                        canvas.width = viewport.width;
                                        page.render({
                                            canvasContext: context,
                                            viewport: viewport
                                        })
                                    }, 2000)
                            }
                        })
                    })
                    .then(() => {
                        vm.loading = false;
                    })
            }

        },
        watch: {
        }
    }
</script>

<style scoped>
    body#portal .pdfModal .modal-footer.pdf-modal-footer {
        margin-top: 20px;
    }
    .modal-body {
        max-height: 600px;
        overflow-y: scroll;
        text-align: center;
        padding-top: 10px;
        margin: 0;
    }
    .spinner-margin {
        margin-top: 30%;
    }
</style>
